import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { radiusTokens } from '@/theme/themePrimitives';

/** Rows of the events table while the page loads (P16). */
const EventsListSkeleton = () => (
  <Stack gap={1.5} sx={{ p: 2 }} aria-busy="true">
    {Array.from({ length: 5 }, (_, index) => (
      <Stack key={index} direction="row" alignItems="center" gap={2}>
        <Skeleton variant="rounded" width={64} height={36} />
        <Stack flex={1} gap={0.5}>
          <Skeleton variant="text" width="40%" />
          <Skeleton variant="text" width="25%" />
        </Stack>
        <Skeleton
          variant="rounded"
          width={88}
          height={24}
          sx={{ borderRadius: radiusTokens.pill }}
        />
      </Stack>
    ))}
  </Stack>
);

export default EventsListSkeleton;
